export const SHOW_MODAL = 'easy-modal/show';
export const HIDE_MODAL = 'easy-modal/hide';
export const REMOVE_MODAL = 'easy-modal/remove';
